module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/manual-usage-299.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/install/manual-usage.md
// module id = 761
// module chunks = 424